import React, { useState } from 'react'
import { reduxForm } from 'redux-form'
import IconButton from '@material-ui/core/IconButton'
import * as actions from '../actions'
import { connect } from 'react-redux'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import ImportExportIcon from '@material-ui/icons/ImportExport'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import SaveAltIcon from '@material-ui/icons/SaveAlt'
import HistoryIcon from '@material-ui/icons/History'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { Dialog } from '@material-ui/core'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Fade from '@material-ui/core/Fade'

import DialogoCOEMsHistorial from '../components/DialogoCOEMsHistorial'
import DialogoCOEMsUpdate from '../components/DialogoCOEMsUpdate'

function EdicionCoem (props) {
  const {
    id,
    registrarCoem,
    rectificarCoem,
    anularCoem,
    cerrarCoem,
    closeModal,
    eliminarCoem,
    solicitarAnulacionCoem,
    solicitarNoABordo
  } = props

  const [openCoems, setOpenCoems] = useState(false)

  const [openCoemHistory, setOpenCoemHistory] = useState(false)

  const handleOpenCoems = () => setOpenCoems(true)

  const handleCloseHistory = () => setOpenCoemHistory(false)

  const handleCloseCoems = () => {
    closeModal()
    setOpenCoems(false)
  }

  function onClickCoems () {
    handleCloseMenu()
    handleOpenCoems()
  }

  const handleSubmitCoems = async () => {
    props.submitActualizarCoems()
  }

  const handleOpenHistory = () => {
    handleCloseMenu()
    setOpenCoemHistory(true)
  }

  const onClickEliminar = (id) => {
    const result = window.confirm('¿Desea ELIMINAR definitivamente el COEM? Este proceso es irreversible si se encuentra Registrado.')
    handleCloseMenu()
    if (result) eliminarCoem(id)
  }

  const onClickRegistrarCoemEnAduana = (id) => {
    const result = window.confirm('¿Desea REGISTRAR el COEM en Aduana?')
    handleCloseMenu()
    if (result) registrarCoem(id)
  }

  const onClickRectificarCoemEnAduana = (id) => {
    const result = window.confirm('¿Desea RECTIFICAR el COEM en Aduana?')
    handleCloseMenu()
    if (result) rectificarCoem(id)
  }

  const onClickAnularCoemEnAduana = (id) => {
    const result = window.confirm('¿Desea ANULAR el COEM en Aduana?')
    handleCloseMenu()
    if (result) anularCoem(id)
  }

  const onClickCerrarCoemEnAduana = (id) => {
    // window.alert('Por favor primero verifique el estado de las solicitudes realizadas en Aduana')
    const result = window.confirm('¿Desea CERRAR el COEM en Aduana?')
    handleCloseMenu()
    if (result) cerrarCoem(id)
  }

  const onClickSolicitarAnulacionCoem = (id) => {
    const result = window.confirm('¿Desea SOLICITAR ANULACION DEL COEM en Aduana?')
    handleCloseMenu()
    if (result) solicitarAnulacionCoem(id)
  }

  const onClickSolicitarNoABordo = (id) => {
    const result = window.confirm('¿Desea SOLICITAR NO A BORDO DEL COEM en Aduana?')
    handleCloseMenu()
    if (result) solicitarNoABordo(id)
  }

  const regresarCoemEstadoAnterior = (id) => {
    const result = window.confirm('¿Desea REGRESAR el COEM al estado SIN REGISTRAR?')
    handleCloseMenu()
    if (result) props.regresarCoemEstadoAnterior(id)
  }

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open1 = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleClickAway = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <div>
        <Dialog
          open={openCoemHistory}
          onClose={handleCloseHistory}
          fullWidth
          maxWidth='lg'>
          <DialogoCOEMsHistorial id={id} handleClose={handleCloseHistory} />
        </Dialog>
        <Dialog
          open={openCoems}
          onClose={handleCloseCoems}
          fullWidth
          maxWidth='md'>
          <DialogoCOEMsUpdate id={id} handleClose={handleCloseCoems} handleSubmit={handleSubmitCoems} />
        </Dialog>
        <ClickAwayListener onClickAway={() => handleClickAway()}>
          <div>
            <IconButton aria-controls='fade-menu' aria-haspopup='true' onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id='fade-menu'
              anchorEl={anchorEl}
              keepMounted
              open={open1}
              onClose={handleCloseMenu}
              TransitionComponent={Fade}
            >
              <MenuItem onClick={onClickCoems}><EditIcon fontSize='small' color='action' />&nbsp;Editar COEM</MenuItem>
              <MenuItem onClick={() => onClickRectificarCoemEnAduana(id)}><PlaylistAddCheckIcon fontSize='small' color='action' />&nbsp;Rectificar COEM</MenuItem>
              <MenuItem onClick={() => onClickAnularCoemEnAduana(id)}><HighlightOffIcon fontSize='small' color='error' />&nbsp;Anular COEM</MenuItem>
              <MenuItem onClick={() => onClickSolicitarAnulacionCoem(id)}><RemoveCircleIcon fontSize='small' color='action' />&nbsp;Solicitar Anulación en Aduana</MenuItem>
              <MenuItem onClick={() => onClickSolicitarNoABordo(id)}><RemoveShoppingCartIcon fontSize='small' color='action' />&nbsp;Solicitar No a Bordo</MenuItem>
              <MenuItem onClick={() => onClickRegistrarCoemEnAduana(id)}><ImportExportIcon fontSize='small' color='action' />&nbsp;Registrar en Aduana</MenuItem>
              <MenuItem onClick={() => onClickCerrarCoemEnAduana(id)}><SaveAltIcon fontSize='small' color='action' />&nbsp;Cierre de COEM Registrado</MenuItem>
              <MenuItem onClick={() => regresarCoemEstadoAnterior(id)}><SettingsBackupRestoreIcon fontSize='small' color='action' />&nbsp;Regresar COEM al estado Sin Registrar</MenuItem>
              <MenuItem onClick={() => onClickEliminar(id)}><DeleteIcon fontSize='small' color='error' />&nbsp;Eliminar COEM</MenuItem>
              <MenuItem onClick={() => handleOpenHistory()}><HistoryIcon fontSize='small' color='action' />&nbsp;Historial</MenuItem>
            </Menu>
          </div>
        </ClickAwayListener>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(EdicionCoem))
